/**
 * Map saved Study Registration document into Administrative Info field names for formData merge.
 * Project identity (trial acronym, sponsor name, protocol id) takes precedence when provided.
 */
import { withProjectIdentityFields } from './projectIdentityFields';

export function studyRegistrationToAdminFields(reg, project = null) {
  if (!reg || typeof reg !== 'object') {
    return project ? withProjectIdentityFields(project, {}) : {};
  }
  const toYmd = (d) => {
    if (!d) return '';
    try {
      const x = new Date(d);
      if (Number.isNaN(x.getTime())) return '';
      return x.toISOString().slice(0, 10);
    } catch {
      return '';
    }
  };
  const fields = {
    sponsor_protocol_identifier: reg.sponsor_primary_study_identifier ?? '',
    sponsor_name: reg.sponsor_name ?? '',
    original_protocol_indicator: reg.original_protocol_indicator ?? '',
    amendment_identifier: reg.amendment_identifier ?? '',
    amendment_scope: reg.amendment_scope ?? '',
    version_number:
      reg.version_number !== undefined && reg.version_number !== null
        ? String(reg.version_number)
        : '',
    version_date: toYmd(reg.version_date),
  };
  return withProjectIdentityFields(project, fields);
}
